export const environment = {
  appVersion: require('../../package.json').version,
  env: ' -- staging',
  themeBaseUrl: '',
  production: false,
  // baseUrl: 'http://localhost:8080/',
  // baseUrl:
  //   'http://package-service-cluster-dev-alb-1279823278.us-east-1.elb.amazonaws.com/',
  baseUrl: 'https://so-api.staging.angeiontestsite.com/api/',
  baseUrlDashboard: 'https://so-api.staging.angeiontestsite.com/dashboard-api/dashboardApp',
  xApiKey: '8lbpjhzZgJ4mO9GmQ5TsxxJBA6o8IN329SwVagw2',
  // formioUrl:'https://ihniktmcnwsxpbo.form.io/case1',
  formio: {
    // baseUrl: 'https://claims-staging.formio.staging.angeiontestsite.com/',
    baseUrl: 'https://api.serverless.staging.angeiontestsite.com/formio/',
    // form_url sent to courtex generic-api (proxy host without /formio)
    formUrlBase: 'https://api.serverless.staging.angeiontestsite.com/',
    lookupFormName: 'servicefindorcreate',
    noValidate: 'hcKlfnDudlPUMwSGnkN3EYxKwjF6pE',
  },
};
